import { render, staticRenderFns } from "./CaptureMediaOrderScript.vue?vue&type=template&id=08fb7c1e&scoped=true&"
import script from "./CaptureMediaOrderScript.vue?vue&type=script&lang=js&"
export * from "./CaptureMediaOrderScript.vue?vue&type=script&lang=js&"
import style0 from "./CaptureMediaOrderScript.vue?vue&type=style&index=0&id=08fb7c1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fb7c1e",
  null
  
)

export default component.exports